import { QueryAtom } from "@/api/types/query.types";
import { Metric } from "@/entities/Finance/Finance.model";
import { FinancialStatement } from "@/entities/Finance/Finance.types";
import { atom } from "jotai";

export const incomeStatementAtom = atom<QueryAtom<FinancialStatement>>({
    data: null,
    isLoading: false,
    isError: false,
});

export const balanceSheetAtom = atom<QueryAtom<FinancialStatement>>({
    data: null,
    isLoading: false,
    isError: false,
});

export const financeMetricsAtom = atom<
    QueryAtom<{ monthly: Metric[]; quarterly: Metric[]; yearly: Metric[] }>
>({
    data: null,
    isLoading: false,
    isError: false,
});

export const finLabMetricsAtom = atom<
    QueryAtom<{ monthly: Metric[]; quarterly: Metric[]; yearly: Metric[] }>
>({
    data: null,
    isLoading: false,
    isError: false,
});
